import { parsePhoneNumberFromString } from "libphonenumber-js/max";

const phoneValidation = (value: any, countryCode?: any) => {
  if (!value) return true;

  const fullNumber = String(
    countryCode ? `${countryCode}${value}` : value
  ).trim();

  try {
    const phone = parsePhoneNumberFromString(fullNumber);

    if (!phone) return false;

    // ✅ library validation
    if (!phone.isValid()) return false;

    const nationalNumber = phone.nationalNumber;

    // 🔥 STRICT RULES (example: India)
    if (phone.country === "IN") {
      return /^[6-9]\d{9}$/.test(nationalNumber);
    }

    // 👉 fallback: accept library validation for others
    return true;
  } catch {
    return false;
  }
};

export default phoneValidation;